(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-reference"] && !Shopify.designMode) return;
  try {
    
(function () {
  // ---- Image Gallery ----
  var thumbs = document.querySelectorAll('.mpr-gallery__thumb');
  var mainImg = document.getElementById('mpr-main-img');

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      thumbs.forEach(function (t) {
        t.classList.remove('mpr-gallery__thumb--active');
        t.setAttribute('aria-current', 'false');
      });
      thumb.classList.add('mpr-gallery__thumb--active');
      thumb.setAttribute('aria-current', 'true');
      if (mainImg) {
        mainImg.style.opacity = '0.6';
        mainImg.src = thumb.dataset.imageSrc;
        mainImg.alt = thumb.dataset.imageAlt;
        mainImg.onload = function () { mainImg.style.opacity = '1'; };
      }
    });
  });

  // ---- Variant Picker ----
  var variantInput = document.getElementById('mpr-variant-input');
  var addToCartBtn = document.getElementById('mpr-add-to-cart');
  var addToCartText = document.getElementById('mpr-add-to-cart-text');
  var priceDisplay = document.getElementById('mpr-price');
  var sizeBtns = document.querySelectorAll('.mpr-size-btn');
  var productData = window.mprProductData || { variants: [] };
  var selectedOptions = {};

  // Init from pre-selected buttons
  document.querySelectorAll('.mpr-size-btn--active').forEach(function (btn) {
    selectedOptions[btn.dataset.optionPosition] = btn.dataset.value;
  });

  function findVariant() {
    return productData.variants.find(function (v) {
      return Object.keys(selectedOptions).every(function (pos) {
        return v['option' + pos] === selectedOptions[pos];
      });
    });
  }

  function formatMoney(cents) {
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    var amount = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  function updateUI(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;

    // Price
    if (priceDisplay) {
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<span class="mpr-price__sale">' + formatMoney(variant.price) + '</span>' +
               '<span class="mpr-price__compare">' + formatMoney(variant.compare_at_price) + '</span>';
      } else {
        html = '<span class="mpr-price__regular">' + formatMoney(variant.price) + '</span>';
      }
      priceDisplay.innerHTML = html;
    }

    // Button
    if (addToCartBtn && addToCartText) {
      var addText = variantInput ? variantInput.dataset.addText : 'Add to Cart';
      var soldText = variantInput ? variantInput.dataset.soldOutText : 'Sold Out';
      if (variant.available) {
        addToCartBtn.disabled = false;
        addToCartBtn.classList.remove('mpr-add-to-cart--disabled');
        addToCartText.textContent = addText;
      } else {
        addToCartBtn.disabled = true;
        addToCartBtn.classList.add('mpr-add-to-cart--disabled');
        addToCartText.textContent = soldText;
      }
    }

    // Image
    if (variant.featured_image && mainImg) {
      mainImg.src = variant.featured_image.src;
      thumbs.forEach(function (t) { t.classList.remove('mpr-gallery__thumb--active'); });
    }

    // URL
    var url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  sizeBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var pos = btn.dataset.optionPosition;
      document.querySelectorAll('.mpr-size-btn[data-option-position="' + pos + '"]').forEach(function (b) {
        b.classList.remove('mpr-size-btn--active');
        b.setAttribute('aria-selected', 'false');
      });
      btn.classList.add('mpr-size-btn--active');
      btn.setAttribute('aria-selected', 'true');
      selectedOptions[pos] = btn.dataset.value;
      var variant = findVariant();
      if (variant) updateUI(variant);
    });
  });

  // ---- Countdown Timer ----
  var display = document.getElementById('mpr-countdown-display');
  if (display) {
    var h = parseInt(display.dataset.hours, 10) || 0;
    var m = parseInt(display.dataset.minutes, 10) || 0;
    var s = parseInt(display.dataset.seconds, 10) || 0;
    var total = h * 3600 + m * 60 + s;

    function pad(n) { return ('0' + n).slice(-2); }
    function tick() {
      if (total <= 0) { display.textContent = '00:00:00'; return; }
      total--;
      display.textContent = pad(Math.floor(total / 3600)) + ':' +
                            pad(Math.floor((total % 3600) / 60)) + ':' +
                            pad(total % 60);
      setTimeout(tick, 1000);
    }
    setTimeout(tick, 1000);
  }

  // ---- Wishlist Toggle ----
  var wishBtn = document.getElementById('mpr-wishlist');
  if (wishBtn) {
    wishBtn.addEventListener('click', function () {
      wishBtn.classList.toggle('mpr-wishlist--active');
    });
  }

  // ---- Recommendations (fetch if not server-rendered) ----
  var recsGrid = document.getElementById('mpr-recs-grid');
  if (recsGrid && recsGrid.dataset.productId && !recsGrid.querySelector('.mpr-recs__card')) {
    fetch('/recommendations/products.json?product_id=' + recsGrid.dataset.productId + '&limit=4')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data.products || !data.products.length) return;
        recsGrid.innerHTML = data.products.map(function (p) {
          var imgSrc = p.featured_image ? p.featured_image.src : null;
          var imgHtml = imgSrc
            ? '<img class="mpr-recs__card-image" src="' + imgSrc + '" alt="' + (p.featured_image.alt || p.title) + '" loading="lazy">'
            : '';
          var saleHtml = '';
          if (p.compare_at_price_max && p.compare_at_price_max > p.price_min) {
            var pct = Math.round((p.compare_at_price_max - p.price_min) * 100 / p.compare_at_price_max);
            saleHtml = '<span class="mpr-recs__price-sale">' + formatMoney(p.price_min) + '</span>' +
                       '<span class="mpr-recs__price-compare">' + formatMoney(p.compare_at_price_max) + '</span>' +
                       '<span class="mpr-recs__price-badge">-' + pct + '%</span>';
          } else {
            saleHtml = '<span class="mpr-recs__price-regular">' + formatMoney(p.price_min) + '</span>';
          }
          return '<a class="mpr-recs__card" href="/products/' + p.handle + '">' +
            '<div class="mpr-recs__card-img">' + imgHtml + '</div>' +
            '<div class="mpr-recs__card-info">' +
              '<p class="mpr-recs__card-title">' + p.title + '</p>' +
              '<div class="mpr-recs__card-stars" aria-hidden="true">★★★★★</div>' +
              '<div class="mpr-recs__card-price">' + saleHtml + '</div>' +
            '</div></a>';
        }).join('');
      })
      .catch(function () {});
  }
})();

  } catch(e) { console.error(e); }
})();
})();
